/* eslint no-use-before-define: 0 */  // --> OFF

import React, { Component }                 from "react";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./pages/general/App.css";
import "./pages/general/Tabs.css";
import { BrowserRouter as Router, Route, }  from "react-router-dom";
import HeaderPage                           from "./pages/general/header.page";
import HeaderDirectorPage                   from "./pages/general/header.director.page";
import HeaderPointSalePage                  from "./pages/general/header.pointsale.page";
import HeaderContadorPage                   from "./pages/general/header.contador.page";
import TabsPage                             from "./pages/general/tabs.page";
import RedirectorPage                       from "./pages/general/redirector.page";
/**
* INVENTARIOS PAGE
*/
import InventariosPage                       from "./pages/general/inventarios.page";
import InventariosMermaPage                  from "./pages/general/inventarios.mermas";
/**
* LOGIN SECTION
**/
import LoginPage                            from "./pages/loginPage/Login.page";
/**
* Section Administrator
**/
//Progreso
import MainProgresoPage                     from "./pages/adminPage/progreso/main.page";
import MainProgresoPageV2                   from "./pages/adminPage/progreso/main.pagev2";
import UpdateCostosPage                     from "./pages/adminPage/progreso/update.costos.page";
import SucursalDirePage                     from "./pages/adminPage/sucursal/sucursal.page";
import TableroDirePage                      from "./pages/adminPage/tablero/main.page";
import GeneralTablePage                     from "./pages/adminPage/progreso/general.table.page";

//Registros
import RegisterGastosPage                   from "./pages/registrosPage/gastos.page";
import RegisterVentaPage                    from "./pages/registrosPage/ventas.page";
import RegisterRutaVentaPage                from "./pages/registrosPage/ventas.ruta.page";
import UploadReportsPage                    from "./pages/registrosPage/subir.reportes.page";
//Clientes
import FacturacionPage                      from "./pages/clientesPage/facturacion.page";

//Register control de productos
import RegisterControlProductos             from "./pages/registrosPage/control.productos.page";

//RH
import RHContador                           from "./pages/rhPage/contador.page";
import Tabla                                from "./pages/rhPage/tabla";


import socketIOClient                       from "socket.io-client";
import moment from 'moment'

const ENDPOINT = "https://wsoft.com.mx:3010";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      debug: 0,
      appConnected: false,
      updateApp: {stat: false, text: '', countFileLocalUpdated: 0, onlySync: false, },
      signedIn: [],
      socket: socketIOClient(ENDPOINT),
      typeHeader: 1,
      viewApp: '__redirector',
      tabsArray: [
        { index: 1, active: 1, img: 'img/hgapp/tab1.png', name: '' },
        { index: 2, active: 0, img: 'img/hgapp/tab3.png', name: '' },
        { index: 3, active: 0, img: 'img/hgapp/tab2.png', name: '' },
        { index: 4, active: 0, img: 'img/hgapp/tab4.png', name: '' },
      ],
      data: {},
      //Admin section Progreso
      tabProgresoActive: 1,
      //Ejecutivo section switch
      renderView: 'nuevaCompra', // def: nuevaCompra
      RTDirector: { text: '', },
      url_facturacion: localStorage.url_facturacion,
      printerActive: localStorage.printerActive === '1' ? 1 : 0,

      dateDire: moment().format('YYYY-MM-DD'),
      arrSucursalSelected: {e: -1, t: {}},
    }

    this.nodeListenByTypeUser  = this.nodeListenByTypeUser.bind(this)
    this.nodeListenDisconnect  = this.nodeListenDisconnect.bind(this)
    this.RTSocketDirector      = this.RTSocketDirector.bind(this)
    this.RTSocketCajero        = this.RTSocketCajero.bind(this)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  getConnectionSocket() {
    this.state.socket.on("connect", this.nodeListenByTypeUser)
    this.state.socket.on("disconnect", this.nodeListenDisconnect)
  }

  nodeListenByTypeUser() {
    const { viewApp, signedIn, } = this.state
    this.setState({ appConnected: true, })

    if(viewApp === '__redirector') {
      //Reintentamos hasta encontrar el viewApp
      setTimeout(() => {this.nodeListenByTypeUser()}, 100)
    } else {
      if(viewApp === 'director') this.state.socket.on("__directorReceive", this.RTSocketDirector);
      if(viewApp === 'ejecutivo') {
        this.state.socket.on("__cajeroReceive", this.RTSocketCajero);
      } else if(viewApp === 'control_sucursal') {
        //Vista Araceli

        if(signedIn.type === 5) {
          this.setState({ renderView: 'nuevaCompraRuta', });
          // this.setState({ renderView: 'altas', });
        } else {
          this.setState({ renderView: 'general', });
        }
      }
    }
  }

  nodeListenDisconnect() {
    this.setState({ appConnected: false, })
  }

  RTSocketDirector(data) {
    const { substrace, signedIn, opt, contractor, } = data

    if( substrace === 'updateVentaPoS' && contractor === 'hg' ) {
      const { apellidos, nombre, sucursal, } = signedIn
      if(opt === 1) {
        //Nueva compra en proceso...

        this.setState({
          RTDirector: {
            text: `${nombre} ${apellidos} está realizando una venta en ${this.state.signedIn.id_usuario !== 'wiwi00_adm' ? sucursal : 'sucursal'}...`,
          }
        })
      } else if(opt === 2) {
        //Compra realizada, recargando

        this.setState({ RTDirector: {
          text: `${nombre} ${apellidos} concluyó una venta en ${this.state.signedIn.id_usuario !== 'wiwi00_adm' ? sucursal : 'sucursal'}.`,
        }})
        setTimeout(() => { this.setState({ RTDirector: { text: `` } })}, 3000)
        if(typeof this.child === 'object') {
          this.child.state.__getProgreso()
        }
      } else if(opt === 0) {
        //Cancelación de compra
        this.setState({ RTDirector: {
          text: `${nombre} ${apellidos} CANCELÓ una venta en ${ this.state.signedIn.id_usuario !== 'wiwi00_adm' ? sucursal : 'sucursal'}.`,
        }})
        setTimeout(() => { this.setState({ RTDirector: { text: `` } })}, 3000)
      }
    }

  }

  RTSocketCajero(data) {
    const { signedIn } = this.state
    const { substrace, suc, } = data

    if(substrace === 'updatePoS') {
      if(suc === 'all' || suc === signedIn.id_sucursal) {
        //Mostrar cargando...
        this.setState({ updateApp: {stat: true, text: 'Iniciando actualización...', countFileLocalUpdated: 0, onlySync: false, }, })
        setTimeout(() => {
          this.makeUpdateEjecutivoApp(1, 'updatePoS')
        }, 300)
      }
    } else if(substrace === 'updateCost') {
      this.setState({ isCambioCostos: true, })
    } else if(substrace === 'setUpdateEntradasAlmacen') {
      //Update arrayCosts
      this.childEjecutivo.state.__updateByOPT(substrace)
    }
  }

  componentDidMount() {
    const { signedIn, } = this.state

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    this.getConnectionSocket()

    if(typeof localStorage.printerActive === 'undefined') {
      this.setState({ printerActive: 1, })
    }

    let param = window.location.search;
    if( param.indexOf('?debug=1') !== -1 )
      this.setState({ debug: 1, });

    if(signedIn === 2) {

      setTimeout(() => {
        //Service autosyncRegs
        this.setState({ updateApp: {stat: true, text: 'Iniciando actualización...', countFileLocalUpdated: 0, onlySync: true, }, })
        this.makeUpdateEjecutivoApp(1, null)
      }, 1000)
    }
  }

  render() {
    let { viewApp } = this.state
    // viewApp = '__redirector'

    return (
      <div style={{
          background: (viewApp === 'director' ? '#fff' : '#f2f2f2'),
          paddingTop: ((viewApp === 'director'|| viewApp === 'facturacion' || viewApp === 'control_inventarios') ? 0 : 50), paddingBottom: 10,
          // background: '#F8F8F9',
          // height: '100%',
          // paddingTop: 0,
        }} className={`${(viewApp === 'login' || viewApp === '__redirector') ? 'ws__login_view' : ''}`}>
        <Router>
          { viewApp === '__redirector' ?
            <Route exact>
              <RedirectorPage nodeListener={ () => this.nodeListenByTypeUser} initState={ this.state } initsetState={ (param, callback) => this.setState(param, callback)} />
            </Route>
          : null }

          <Route exact path="/login">
            <LoginPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>

          { /* <GeneralTablePage initState={ this.state } initsetState={ (param) => this.setState(param)} /> */ }
          {/*<TablaUtilidadesMaster initState={ this.state } initsetState={ (param) => this.setState(param)} />*/}
          {/*<Tabla initState={ this.state } initsetState={ (param) => this.setState(param)} />*/}

          { viewApp === 'facturacion' ? this.makeRenderFacturacion() : null }
          { viewApp === 'director' ? this.makeRenderDirector() : null }
          { viewApp === 'ejecutivo' ? this.makeRenderEjecutivo() : null }
          { viewApp === 'control_productos' ? this.makeRenderControlProductos() : null }
          { viewApp === 'rh_contable' ? this.makeRenderRHContable() : null }
          { viewApp === 'control_sucursal' ? this.makeRenderControlSucursal() : null }
          { viewApp === 'tabla_diaria_productos' ? <Tabla initState={ this.state } initsetState={ (param) => this.setState(param)} /> : null }
          { viewApp === 'tabla_productividad_general' ? <GeneralTablePage initState={ this.state } initsetState={ (param) => this.setState(param)} /> : null }
          { viewApp === 'control_inventarios' ? this.makeRenderInventarios() : null }
          

        </Router>
      </div>
    );
  }

  makeRenderFacturacion() {
    return (
      <>
        {/* Header */}

          <Route exact path="/">
            <FacturacionPage
              initState={ this.state }
              initsetState={ (param) => this.setState(param)}
              onRef={ref => (this.child = ref)}
            />
          </Route>
      </>
    )
  }

  makeRenderDirector() {
    const { tabProgresoActive, tabsArray } = this.state

    let indexActiveDire = -1
    tabsArray.map((t) => { if(t.active === 1) { indexActiveDire = t.index } })
    // indexActiveDire = 3

    return (
      <>
        {/* Header */}
        <HeaderDirectorPage initState={ this.state } initsetState={ (param) => this.setState(param) } />

          <Route exact path="/">
            { indexActiveDire === 1 ?
              <MainProgresoPageV2
                initState={ this.state }
                initsetState={ (param) => this.setState(param)}
                onRef={ref => (this.child = ref)}
              /> : null
            }

            { indexActiveDire === 2 ?
              <SucursalDirePage
                initState={ this.state }
                initsetState={ (param) => this.setState(param)}
                onRef={ref => (this.child = ref)}
              /> : null
            }

            { indexActiveDire === 3 ?
              <TableroDirePage
                initState={ this.state }
                initsetState={ (param) => this.setState(param)}
                onRef={ref => (this.child = ref)}
              /> : null
            }


          </Route>

          <Route exact path="/registra-gastos">
            <RegisterGastosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>

          <Route exact path="/actualiza-costos">
            <UpdateCostosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>
        {/* Tabs */}
        <TabsPage initState={ this.state } initsetState={ (param) => this.setState(param) } />
      </>
    )
  }

  makeRenderEjecutivo() {
    const { renderView } = this.state

    return (
      <div style={{ background: (renderView === 'nuevaCompra' ? '#f3f3f3' : '#fff'), }}>
        <Router>
          {/* Header */}
          <HeaderPointSalePage initState={ this.state } initsetState={ (param) => this.setState(param) } />

            <Route type={0} exact path="/" initState={ this.state }>
              <RegisterVentaPage
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
            <Route exact path="/registra-gastos">
              <RegisterGastosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>

          {/* Tabs */}
          {/*<TabsPage initState={ this.state } initsetState={ (param) => this.setState(param) } />*/}
        </Router>
      </div>
    )
  }

  makeRenderControlSucursal() {
    const { renderView } = this.state

    return (
      <div style={{ background: (renderView === 'nuevaCompra' ? '#f3f3f3' : '#fff'), }}>
        <Router>
          {/* Header */}
          <HeaderPointSalePage initState={ this.state } initsetState={ (param) => this.setState(param) } />

            <Route type={0} exact path="/" initState={ this.state }>
              <RegisterRutaVentaPage
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
            <Route exact path="/registra-gastos">
              <RegisterGastosPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
        </Router>
      </div>
    )
  }

  makeRenderInventarios() {
    const { renderView } = this.state

    return (
      <div style={{ background: (renderView === 'nuevaCompra' ? '#f3f3f3' : '#fff'), }}>
        <Router>
          {/*<Route type={0} exact path="/" initState={ this.state }>
            <InventariosPage
              onRef={refEj => (this.childEjecutivo = refEj)}
              initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>*/}
          <Route type={0} exact path="/" initState={ this.state }>
            {/*<InventariosMermaPage
              onRef={refEj => (this.childEjecutivo = refEj)}
              initState={ this.state } initsetState={ (param) => this.setState(param)} />*/}
            <InventariosPage
              onRef={refEj => (this.childEjecutivo = refEj)}
              initState={ this.state } initsetState={ (param) => this.setState(param)} />
          </Route>
        </Router>
      </div>
    )
  }

  makeRenderControlProductos() {
    const { renderView } = this.state

    return (
      <div style={{ background: '#f3f3f3', }}>
        <Router>
          {/* Header */}
          <HeaderPointSalePage initState={ this.state } initsetState={ (param) => this.setState(param) } />
            <Route type={0} exact path="/" initState={ this.state }>
              <RegisterControlProductos
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
        </Router>
      </div>
    )
  }

  makeRenderRHContable() {
    const { renderView } = this.state

    return (
      <div style={{ background: '#f3f3f3', }}>
        <Router>
          {/* Header */}
          <HeaderContadorPage initState={ this.state } initsetState={ (param) => this.setState(param) } />
            <Route type={0} exact path="/" initState={ this.state }>
              <RHContador
                onRef={refEj => (this.childEjecutivo = refEj)}
                initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
        </Router>
      </div>
    )
  }

  makeUpdateEjecutivoApp(opt, isUpdate) {
    let { countFileLocalUpdated, onlySync, } = this.state.updateApp
    if(opt === 1) {
      //Si es 1 verifica y pide un doc a sincronizar...
      //Paso 1 sincronizar todas las ventas sin enviar
      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=syncVentasLocal", this.headersPOST({  }))
      .then(response => response.json())
      .then((response) => {
        countFileLocalUpdated = (countFileLocalUpdated + 1)
        this.setState({ updateApp: {stat: true, text: `Sicronizando registros sin enviar #${(countFileLocalUpdated)}...`, countFileLocalUpdated }, })

        //Si ya no hay documentos por sincronizar comenzamos a actualizar...
        if(response.can === 0) {
          if(onlySync) {
            this.setState({ updateApp: {stat: false, text: '', countFileLocalUpdated: 0, onlySync: true, }, })
          } else {
            this.makeUpdateEjecutivoApp(2, isUpdate)
          }
        } else {
          if(response.type === 'venta') {
            fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterNewVenta", this.headersPOST({ ...response.data, }))
            .then(response0 => response0.json())
            .then((response0) => {
              if(response0.status === 'ok') {
                //Delete local file
                fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRemoveLocalVenta", this.headersPOST({file: response.file}))
                .then(response1 => response1.json())
                .then((response1) => {
                  setTimeout(() => { this.makeUpdateEjecutivoApp(1, isUpdate) }, 1000)
                }).catch((error) => {
                  setTimeout(() => { this.makeUpdateEjecutivoApp(1, isUpdate) }, 1000)
                })
              }
            }).catch((error) => {
              setTimeout(() => { this.makeUpdateEjecutivoApp(1, isUpdate) }, 1000)
            })
          } else if(response.type === 'corte') {
            fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterNewCorte", this.headersPOST({ ...response.data, }))
            .then(response0 => response0.json())
            .then((response0) => {
              fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRemoveLocalVenta", this.headersPOST({file: response.file}))
              .then(response1 => response1.json())
              .then((response1) => {
                setTimeout(() => { this.makeUpdateEjecutivoApp(1, isUpdate) }, 1000)
              }).catch((error) => {
                setTimeout(() => { this.makeUpdateEjecutivoApp(1, isUpdate) }, 1000)
              })
            }).catch((error) => {
              setTimeout(() => { this.makeUpdateEjecutivoApp(1, isUpdate) }, 1000)
            });
          }
        }
      })
      .catch((error) => {
        // alert('Ocurrió un error al intentar sincronizar las ventas. Contacta a tu administrador.')
        this.setState({ updateApp: {stat: false, text: '', countFileLocalUpdated: 0, onlySync: true, }, })
        // window.location.reload()
      })

    } else if(isUpdate === 'updatePoS') {
      //Si es dos manda actualizar la paquetería

      //Paso 2 actualizar
      this.setState({ updateApp: {stat: true, text: 'Actualizando sistema...',}, })

      //Paso 3 recargar sitio para aplicar cambios

      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=updatePoS", {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({}),
      })
      .then(response => response.json())
      .then((response) => {
        this.setState({ updateApp: {stat: true, text: 'Actualización realizada con éxito. Recargando...',}, })
        alert( 'Actualización realizada con éxito. Recargando...' )
        window.location.reload()
      })

    }
  }

  /**
  * UPLOAD ACCOUNT
  **/
  makeRenderUpload() {
    return (
      <div style={{ background: '#fff', height: '100%', paddingTop: '50px', }}>
        <Router>
          {/* Header */}
          <HeaderPage type={0} initState={ this.state } initsetState={ (param) => this.setState(param) } />
            <Route exact path="/">
              <UploadReportsPage initState={ this.state } initsetState={ (param) => this.setState(param)} />
            </Route>
          {/* Tabs */}
        </Router>
      </div>
    );
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

}

export default App;




